export const compensationActionTypes = {
    STORE_COMPENSATION_TICKETS: "STORE_COMPENSATION_TICKETS",
    STORE_COMPENSATION_TICKET: "STORE_COMPENSATION_TICKET"
}